import React from "react";

import Accueil from '../../assets/images/mlk/MLK_accueil.png'; // Image est en 1600x900
import Bus from '../../assets/images/mlk/MLK_bus.png';
import Oeuvre from '../../assets/images/mlk/MLK_oeuvre.png';

function Project_mlk() {
    return(
    <div className="projects-windows" id="projects">
        <h1>Martin Luther King Jr et muséee virtuel : Faire redécouvrir son combats, de maniére ludique.</h1>
        <p>Lors du projet final de première année de BUT Informatique, notre groupe de six étudiants avait pour objectif de recréer 
            un environnement virtuel, sous la forme d’un jeu vidéo, représentant le combat de Martin Luther King Jr. Ce projet vise à 
            faire découvrir son combat pour les droits civiques et l'égalité des afro-américain au plus grand nombre, à travers un jeu 
            ludique, éducatif et accessible à tous. En combinant nos compétences en programmation, en design et en narration, nous avons 
            cherché à créer une expérience qui non seulement divertit, mais aussi éduque et inspire les joueurs sur l'importance
            historique du combat de Martin Luther King Jr.
        </p><br></br>
        <img className="img"src={Accueil} alt="Accueil du jeu" ></img><br></br>
        <i>Page d'accueil</i><br></br>
        <h2>Outils utilisé:</h2>
        <p> -Unreal<br></br>
            -3DS Max<br></br>
            -Substance Painter<br></br><br></br><br></br>
        <h2>Langage utilisé:</h2>
            <p>-C++</p><br></br>

        <h2>La création</h2>
            <p>Pour réalisez ce projet, nous avons répartie les taches selon les forces de chacun.
                Nous avons aussi réalisé des réunion pour observé les avancement de chacun
                Parmi les grand étapes de création : <br></br>
                        - La création du scénario et du parcours de l'utilisateurs dans le musée <br></br>
                        - La préparation des différents asset (statues, peintures,voix,décors)<br></br>
                        - Mise en place du monde et création des scripts en C++<br></br>
                        - La mise en place final, gestion des ressources, et correction des différend bug<br></br>
                        - demonstration du jeux<br></br></p>
                <p>De plus, afin de menée ce projet a bien, les compétences de gestion de projet et de communication, appris tout du long du BUT informatique,
                était important. En effet, ces compétences et soft skill nous ont permis de gardé un cap clair tout au long de ce projet,
                que ce soit les date butoir ou la présentation final, tout les partie du projet les on nécessité.
            </p>
        </p><br></br>
        <figure>
            <img className="img" src={Bus} alt="Bus transportent le joueur jusqu'au musée"></img><br></br><br></br>
            <figcaption>Bus transportent le joueur jusqu'au musée</figcaption>
        </figure><br></br>
        <p>L'objectif principal de ce projet était de créer un jeu vidéo éducatif et interactif pour sensibiliser les joueurs 
            au combat de Martin Luther King Jr. Nous souhaitions offrir une expérience immersive et accessible à tous les utilisateurs, 
            tout en explorant les possibilités offertes par les technologies de développement en 3D et en temps réel. <br></br>

        Cette première expérience dans la création d'un musée virtuel nous a permis de plonger dans l'univers du développement 
        de jeux vidéo. Nous avons découvert et maîtrisé plusieurs outils essentiels tels qu'Unreal Engine et 3ds Max. Cette immersion 
        nous a offert l'opportunité de développer nos compétences dans divers domaines clés de la création de jeux, notamment : 
        la modélisation 3D, la programmation en C++ et blueprints, le Game design,etc…<br></br>

        Un projet de cette envergure, qui a pris plus de deux mois à être réalisé, nous a également appris à gérer 
        efficacement un projet en équipe. Nous avons développé des compétences essentielles en gestion du temps, en communication 
        au sein du groupe, et en entraide entre les membres. Ces expériences nous ont rendus plus matures et nous ont permis de gagner 
        en expérience dans le domaine de la création de jeux vidéo.<br></br>
        </p><br></br>

            <img className="img" src={Oeuvre} alt="Oeuvre a l'intérieur du musée"></img><br></br>
            <p><i>L'intérieur du musée</i></p><br></br>
    </div>
    );
}

export default Project_mlk;